import { themes, type Theme } from '@/components/theme/ThemeSelector';

export function initializeThemes() {
  // Load and apply dark/light mode
  const savedMode = localStorage.getItem('urban-finch-theme');
  if (savedMode) {
    const root = window.document.documentElement;
    root.classList.remove('light', 'dark');
    
    if (savedMode === 'system') {
      const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches
        ? 'dark'
        : 'light';
      root.classList.add(systemTheme);
    } else {
      root.classList.add(savedMode);
    }
  }
  
  // Load color theme from localStorage
  const savedColorTheme = localStorage.getItem('color-theme') as Theme;
  if (savedColorTheme && themes.find(t => t.id === savedColorTheme)) {
    applyColorTheme(savedColorTheme);
  }
}

// Keep for backward compatibility
export function initializeColorTheme() {
  initializeThemes();
}

export function applyColorTheme(themeId: Theme) {
  // Remove existing theme stylesheets
  const existingThemeLinks = document.querySelectorAll('link[data-theme]');
  existingThemeLinks.forEach(link => link.remove());

  const colorTheme = themes.find(t => t.id === themeId);
  if (!colorTheme) return;

  if (colorTheme.cssFile) {
    // Load the theme CSS file
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = colorTheme.cssFile;
    link.setAttribute('data-theme', themeId);
    document.head.appendChild(link);
  }
  // Default theme doesn't need additional CSS as it's already in index.css
}